import Vue from 'vue'
import Router from 'vue-router'
import iView from "iview";
import store from "./vuex";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/main',
      meta: {
        title: '主页',
        requireAuth: true,
      },
      component: () => import('@/components/Layout'),
      children: [
        {
          path: '/home',
          name: 'home',
          meta: {
            title: '',
            requireAuth: true,
          },
          component: () => import('@/views/Home')
        },
        {
          path: 'questionnaire',
          name: 'questionnaire',
          meta: {
            title: '问卷管理',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaire')
        },
        {
          path: 'questionnaireWrite',
          name: 'questionnaireWrite',
          meta: {
            title: '问卷填写',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaireWrite')
        },
        {
          path: 'questionnaireResult',
          name: 'questionnaireResult',
          meta: {
            title: '问卷结果',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaireResult')
        },
        {
          path: 'questionnaireStatistics',
          name: 'questionnaireStatistics',
          meta: {
            title: '问卷统计',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaireStatistics')
        },
        {
          path: 'questionnaire_type',
          name: 'questionnaire_type',
          meta: {
            title: '问卷类型管理',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaire_type')
        },
        {
          path: 'questionnaire_bind',
          name: 'questionnaire_bind',
          meta: {
            title: '特殊问卷绑定',
            requireAuth: true,
          },
          component: () => import('@/views/questionnaire/questionnaire_bind')
        },
        {
          path: 'articleType',
          name: 'articleType',
          meta: {
            title: '文章分类管理',
            requireAuth: true,
          },
          component: () => import('@/views/articles_trends/articleType')
        },
        {
          path: 'articles',
          name: 'articles',
          meta: {
            title: '文章管理',
            requireAuth: true,
          },
          component: () => import('@/views/articles_trends/articles')
        },
        {
          path: 'articleDIYType',
          name: 'articleDIYType',
          meta: {
            title: '饮食DIY分类管理',
            requireAuth: true,
          },
          component: () => import('@/views/articles_trends/articleDIYType')
        },
          {
              path: 'articlesDIY',
              name: 'articlesDIY',
              meta: {
                  title: '饮食DIY',
                  requireAuth: true,
              },
              component: () => import('@/views/articles_trends/articlesDIY')
          },
        // {
        //     path: '/share',
        //     name: 'share',
        //     meta: {
        //         title: '患者分享',
        //         requireAuth: true,
        //     },
        //     component: () => import('@/views/articles_trends/share')
        // },
        {
          path: 'user',
          name: 'user',
          meta: {
            title: '患者账号',
            requireAuth: true,
          },
          component: () => import('@/views/user/user')
        },
        {
          path: 'pcAnalyzeDietLog',
          name: 'pcAnalyzeDietLog',
          meta: {
            title: '饮食分析',
            requireAuth: true,
          },
          component: () => import('@/views/user/pcAnalyzeDietLog')
        },
        {
          path: 'nutritionalGoals',
          name: 'nutritionalGoals',
          meta: {
            title: '营养目标',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/nutritionalGoals')
        },
        {
            path: 'doctor',
            name: 'doctor',
            meta: {
                title: '医生管理',
                requireAuth: true,
            },
            component: () => import('@/views/doctor/doctor')
        },
          {
              path: 'doctorSchedule',
              name: 'doctorSchedule',
              meta: {
                  title: '医生日程',
                  requireAuth: true,
              },
              component: () => import('@/views/doctor/doctorSchedule')
          },
        {
          path: 'dietitian',
          name: 'dietitian',
          meta: {
            title: '医助管理',
            requireAuth: true,
          },
          component: () => import('@/views/doctor/dietitian')
        },
        {
            path: 'doctorTime',
            name: 'doctorTime',
            meta: {
              title: '预约管理',
              requireAuth: true,
            },
            component: () => import('@/views/doctor/doctorTime')
        },
        // {
        //     path: '/doctorIM',
        //     name: 'doctorIM',
        //     meta: {
        //         title: '医生咨询',
        //         requireAuth: true,
        //     },
        //     component: () => import('@/views/doctor/doctorIM')
        // },
        // {
        //     path: '/doctorRTC',
        //     name: 'doctorRTC',
        //     meta: {
        //         title: '视频通话',
        //         requireAuth: true,
        //     },
        //     component: () => import('@/views/doctor/doctorRTC')
        // },
        {
          path: 'medicalRecord',
          name: 'medicalRecord',
          meta: {
            title: '病历管理',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/medicalRecord')
        },
        {
          path: 'prescription',
          name: 'prescription',
          meta: {
            title: '处方管理',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/prescription')
        },
        {
            path: 'doctorOrder',
            name: 'doctorOrder',
            meta: {
                title: '面诊预约',
                requireAuth: true,
            },
            component: () => import('@/views/doctor/doctorOrder')
        },
        {
          path: 'medicine',
          name: 'medicine',
          meta: {
            title: '药品管理',
            requireAuth: true,
          },
          component: () => import('@/views/Medicine/medicine')
        },
        {
          path: 'nutrient',
          name: 'nutrient',
          meta: {
            title: '营养素管理',
            requireAuth: true,
          },
          component: () => import('@/views/Medicine/nutrient')
        },
        {
          path: 'doctorAdvice',
          name: 'doctorAdvice',
          meta: {
            title: '医嘱管理',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/doctorAdvice')
        },
        {
          path: 'dietGuidelines',
          name: 'dietGuidelines',
          meta: {
            title: '饮食原则',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/dietGuidelines')
        },
        {
          path: 'dietPlan',
          name: 'dietPlan',
          meta: {
            title: '饮食计划',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/dietPlan')
        },
        {
          path: 'dietGuidlineFoods',
          name: 'dietGuidlineFoods',
          meta: {
            title: '饮食原则食材',
            requireAuth: true,
          },
          component: () => import('@/views/food/dietGuidlineFood')
        },
        {
          path: 'dietPlanTemplate',
          name: 'dietPlanTemplate',
          meta: {
            title: '饮食计划模板',
            requireAuth: true,
          },
          component: () => import('@/views/diagnosis/dietPlanTemplate')
        },
        {
          path: 'dietLog',
          name: 'dietLog',
          meta: {
            title: '饮食日志',
            requireAuth: true,
          },
          component: () => import('@/views/user/dietLog')
        },
        {
          path: 'message',
          name: 'message',
          meta: {
            title: '患者留言',
            requireAuth: true,
          },
          component: () => import('@/views/user/message')
        },
          {
              path: 'messagePro',
              name: 'messagePro',
              meta: {
                  title: '健康咨询',
                  requireAuth: true,
              },
              component: () => import('@/views/user/messagePro')
          },
        {
          path: 'foodMaterial',
          name: 'foodMaterial',
          meta: {
            title: '食材',
            requireAuth: true,
          },
          component: () => import('@/views/food/foodMaterial')
        },
        {
          path: 'foodMaterialType',
          name: 'foodMaterialType',
          meta: {
            title: '食材类别',
            requireAuth: true,
          },
          component: () => import('@/views/food/foodMaterialType')
        },
        {
          path: 'nutrition',
          name: 'nutrition',
          meta: {
            title: '营养物质',
            requireAuth: true,
          },
          component: () => import('@/views/food/nutrition')
        },
        // {
        //     path: '/allergen',
        //     name: 'allergen',
        //     meta: {
        //         title: '过敏信息',
        //         requireAuth: true,
        //     },
        //     component: () => import('@/views/checkReportForms/allergen')
        // },
        {
          path: 'medicalObject',
          name: 'medicalObject',
          meta: {
            title: '检查项目',
            requireAuth: true,
          },
          component: () => import('@/views/checkReportForms/medicalObject')
        },
        {
          path: 'medicalOrder',
          name: 'medicalOrder',
          meta: {
            title: '检查订单',
            requireAuth: true,
          },
          component: () => import('@/views/checkReportForms/medicalOrder')
        },
        {
          path: 'medicalReport',
          name: 'medicalReport',
          meta: {
            title: '检查报告',
            requireAuth: true,
          },
          component: () => import('@/views/checkReportForms/medicalReport')
        },
        {
          path: 'weiXinMessage',
          name: 'weiXinMessage',
          meta: {
            title: '微信推送',
            requireAuth: true,
          },
          component: () => import('@/views/weiXin/weiXinMessage')
        },
        {
          path: 'simpleQuestion',
          name: 'simpleQuestion',
          meta: {
            title: '常见问题',
            requireAuth: true,
          },
          component: () => import('@/views/weiXin/simpleQuestion')
        },
        // {
        //     path: '/webIM',
        //     name: 'webIM',
        //     meta: {title: '在线客服'},
        //     component: () => import('@/views/weiXin/webIM')
        // },
        {
          path: 'systemUser',
          name: 'systemUser',
          meta: {
            title: '后台用户',
            requireAuth: true,
          },
          component: () => import('@/views/system/systemUser')
        },
        {
          path: 'permissionRole',
          name: 'permissionRole',
          meta: {
            title: '角色权限',
            requireAuth: true,
          },
          component: () => import('@/views/system/permissionRole')
        },
        {
          path: 'files',
          name: 'files',
          meta: {
            title: '文件管理',
            requireAuth: true,
          },
          component: () => import('@/views/system/files')
        },
        {
          path: 'systemUserLoginLog',
          name: 'systemUserLoginLog',
          meta: {
            title: '登陆历史',
            requireAuth: true,
          },
          component: () => import('@/views/system/systemUserLoginLog')
        },
        {
          path: '/systemUserInfo',
          name: 'systemUserInfo',
          meta: {
            title: '管理员信息',
            requireAuth: true,
          },
          component: () => import('@/views/system/systemUserInfo')
        },
      ]
    },
    {
      path: '/doctor_manage',
      meta: {title: 'doctor_manage'},
      component: () => import('@/views/doctor_manage/doctor_main'),
      children: [
        {
          path: '',
          name: 'doctor',
          meta: {title: 'doctor'},
          component: () => import('@/views/doctor_manage/show-info-module')
        },
        {
          path: 'diagnoseHistory',
          name: 'diagnosehistory',
          meta: {title: 'history'},
          component: () => import('@/views/doctor_manage/diagnose-history-module.vue')
        },{
          path: 'medicalRecords',
          name: 'medicalRecords',
          meta: {title: 'showInfo'},
        component: () => import('@/views/doctor_manage/medical_record_new')
        // TODO: 把组件改回引用以下组件
          // component: () => import('@/views/doctor_manage/medical_records')
        },{
            path: 'medicalRecordsFollow',
            name: 'medicalRecordsFollow',
            meta: {title: 'showInfo'},
            component: () => import('@/views/doctor_manage/medical_follow_new')
    },{
        path: 'patientReport',
            name: 'patientReport',
            meta: {title: 'showInfo'},
        component: () => import('@/views/doctor_manage/patientReport')
    },
        {
            path: 'userTestOrder',
                name: 'userTestOrder',
            meta: {
            title: '患者订单',
                requireAuth: true,
        },
            component: () => import('@/views/checkReportForms/userTestOrder')
        },
        {
            path: '/patientQuestionnaireResult',
                name: 'patientQuestionnaireResult',
            meta: {title: 'showInfo'},
            component: () => import('@/views/doctor_manage/patientQuestionnaireResult')
        },
        {
            path: 'questionWrite',
                name: 'questionWrite',
            meta: {title: 'showInfo'},
            component: () => import('@/views/doctor_manage/questionWrite')
        },
      ]
    },
    {
      path: '/',
      meta: {title: '登录',login: true},
      component: () => import('@/views/Login')
    },
    {
      path: '*',
      meta: {title: '登录',login: true},
      component: () => import('@/views/Login')
    }
  ]
})
